export const sortByLocaleCompare = <T>(items: T[], value: keyof T): T[] => {
  return items.sort((a, b) => {
    const aValue = a[value]
    const bValue = b[value]

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return aValue.localeCompare(bValue)
    }

    return 0
  })
}
